// ── CartDrawer custom element ─────────────────────────────────────────────────
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this._onKeyUp = this._onKeyUp.bind(this);
      this._onOutsideClick = this._onOutsideClick.bind(this);
    }

    connectedCallback() {
      document.addEventListener('click', this._onOutsideClick);
      document.addEventListener('keyup', this._onKeyUp);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onOutsideClick);
      document.removeEventListener('keyup', this._onKeyUp);
    }

    open() {
      this.removeAttribute('inert');
      this.setAttribute('aria-hidden', 'false');

      if (this._observer) this._observer.disconnect();
      this._observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'inert') {
            if (this.hasAttribute('inert')) this.removeAttribute('inert');
          }
        });
      });
      this._observer.observe(this, { attributes: true });
      setTimeout(() => { if (this._observer) this._observer.disconnect(); }, 2000);
    }

    close() {
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      if (this._observer) this._observer.disconnect();
    }

    _onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }

    _onOutsideClick(event) {
      if (!this.contains(event.target) && !event.target.closest('[data-cart-toggle], #cart-drawer-toggle, .thb-cart, .cart-icon, .thb-secondary-area')) {
        if (!this.hasAttribute('inert')) this.close();
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

// ── Standard Shopify events (product pages) ───────────────────────────────────
document.addEventListener('cart:item-added', () => {
  const drawer = document.getElementById('Cart-Drawer');
  if (drawer) drawer.open();
});

document.addEventListener('cart:refresh', () => {
  const drawer = document.getElementById('Cart-Drawer');
  if (drawer) drawer.open();
});

// ── Fetch interceptor for carousel app ───────────────────────────────────────
// Patches window.fetch to detect POST to /cart/add.js only (not GET /cart.js)
// Makes exactly ONE sections fetch after a successful add, then opens drawer.
(function patchFetch() {
  const _originalFetch = window.fetch;
  let _pending = false;

  async function updateAndOpenDrawer() {
    if (_pending) return;
    _pending = true;
    try {
      const res = await _originalFetch('/?sections=cart-drawer,cart-bubble', { cache: 'no-store' });
      if (!res.ok) return;
      const sections = await res.json();

      const drawerEl = document.getElementById('Cart-Drawer');
      if (drawerEl && sections['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawer = parsed.querySelector('.cart-drawer');
        if (newDrawer) drawerEl.innerHTML = newDrawer.innerHTML;
        drawerEl.open();
      }

      if (sections['cart-bubble']) {
        const parsed = new DOMParser().parseFromString(sections['cart-bubble'], 'text/html');
        ['thb-secondary-area--item-count', 'thb-secondary-area--item-amount'].forEach(cls => {
          const target = document.querySelector('.' + cls);
          const source = parsed.querySelector('.' + cls);
          if (target && source) target.innerHTML = source.innerHTML;
        });
      }
    } catch (e) {
      console.error('[cart-drawer] update error:', e);
    } finally {
      _pending = false;
    }
  }

  window.fetch = async function(...args) {
    const req = args[0];
    const url = typeof req === 'string' ? req : (req instanceof Request ? req.url : '');
    const method = (args[1]?.method || (req instanceof Request ? req.method : 'GET')).toUpperCase();

    // Only intercept POST to /cart/add — nothing else
    const isCartAdd = method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);

    const response = await _originalFetch.apply(this, args);

    if (isCartAdd && response.ok) {
      // Wait 200ms for the carousel app to finish its own handling, then update
      setTimeout(updateAndOpenDrawer, 200);
    }

    return response;
  };
})();